import type { GalleryContentQuery } from 'shared/types/gallery/content-query'
import type { GalleryModelsUrl } from 'shared/types/gallery/models'

export const buildPriceDisplaySelections = (
  selections: GalleryContentQuery.ProductOptions,
  quantity?: GalleryModelsUrl.ValidParsedQsValue<number>,
): GalleryContentQuery.ProductOptions => ((quantity ?? 0) > 0 ? { ...selections, quantity: String(quantity) } : selections)
